import triggerTypes from '../constants/trigger-types';
import findAllFor from './find-all-for';

const findAllHoveredFor = (element) => findAllFor(element, triggerTypes.HOVER);

export default findAllHoveredFor;
